import * as React from 'react';
import {observer} from "mobx-react-lite";
import {Redirect} from "react-router-dom"
import CheckLogsData from "../components/CheckLogs/CheckLogsData";
import LogsStore from "../stores/logs";

const CheckLogsPage = observer(function CheckLogsPage(props: { store: LogsStore }) {
    if (!props.store.data) {
        return <Redirect to="/"/>
    }

    return <CheckLogsData
        data={props.store.data}
        totalFound={props.store.totalFound}
        uniqueFound={props.store.uniqueFound}
        truncated={props.store.truncated}
    />
})

export default CheckLogsPage